import React, {useRef, useState} from 'react';
import {Toast} from "primereact/toast";
import {ContainerGroupForm} from "../../../../components/Containers/ContainerGroupForm";
import {anios, meses} from "../../../../shared/types/constantes";
import {arrayNum} from "../../../../shared/utils/utils";
import {UseLoader} from "../../../../hooks/useLoader";
import {traerFacturasPendientes} from "../../../../api/liquidacion.service";

import {UsePermissions} from "../../../../hooks/usePermissions";

import {Navigate} from "react-router";
import {TablePagoLiquidacion} from "./TablePagoLiquidacion";

export const PagoLiquidacion = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const initParams = {
        anio: "",
        mes: "",
        periodo: "",
    };
    const [field, setField] = useState(initParams);
    const [pendientesLiquidar, setPendientesLiquidar] = useState([]);

    const periodo = arrayNum(50);


    const buscarInfoFactura=async (e) => {
        e.preventDefault();

       await buscar()
    }

    const buscarInfoFacturaParen=async () => {
        await buscar()
    }

    const buscar = async () => {

        try {
            for (let f in field) {
                if (field[f] === '') {
                    if (f === 'anio') f = 'Año';
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: `El campo ${f} es obligatorio`,
                        life: 3000
                    });
                    return;
                }
            }
            handleLoad(true);
            const response = await traerFacturasPendientes(field);
            handleLoad(false);

            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                setPendientesLiquidar([]);
                return;
            }
            setPendientesLiquidar(response.data)
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }
    return (
        <>
            <Toast ref={toast}/>

            <div className=" flex flex-wrap items-center  p-4 primary-color">
                <div className=" mt-2 relative lg:w-8/12 px-4">
                    <form onSubmit={buscarInfoFactura}>
                        <div className="row">
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="anio"
                                >
                                    Año *
                                </label>
                                <select value={field.anio} name="periodo"
                                        className="form-input"
                                        onChange={(e) => setField({...field, anio: e.target.value})}
                                        id="anio">
                                    <option value="">...</option>
                                    {anios.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                </select>

                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="mes"
                                >
                                    Mes *
                                </label>
                                <select value={field.mes} name="mes"
                                        className="form-input"
                                        onChange={(e) => setField({...field, mes: e.target.value})}
                                        id="periodo">
                                    <option value="">...</option>
                                    {meses.map((p, i) => <option key={i} value={p.value}>{p.name}</option>)}
                                </select>


                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="periodo"
                                >
                                    Periodo *
                                </label>
                                <select value={field.periodo} name="periodo"
                                        className="form-input"
                                        onChange={(e) => setField({...field, periodo: e.target.value})}
                                        id="periodo">
                                    <option value="">...</option>
                                    {periodo.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                </select>


                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <div className="mt-6 relative w-full px-4">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Buscar
                                    </button>
                                </div>

                            </ContainerGroupForm>
                        </div>
                    </form>
                </div>

            </div>
            <div className="container-relative mt-3 ">
                {permisos.consultar ? <TablePagoLiquidacion reload={buscarInfoFacturaParen} pendientes={pendientesLiquidar} />: <Navigate to="/home"/> }
            </div>

        </>
    );
};


